export default {
  LINK_CONFIG_ATTRIBUTE: 'ws-link-config',
  NOFOLLOW: 'nofollow',
  BLANK: '_blank',
};
